import { Link } from 'react-router-dom';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import PlaceIcon from '@mui/icons-material/Place';
import './index.css';

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <Link to="/">
            <img src="./logo/logo_cropped.png" alt="Riga Dentique" className="footer-logo-img" />
          </Link>
          <div className="footer-brand-divider" />
          <p className="footer-tagline">Private Dental Clinic</p>
        </div>

        <div className="footer-nav">
          <Link to="/" className="footer-link">
            Home
          </Link>
          <Link to="/about" className="footer-link">
            About Us
          </Link>
          <Link to="/pricing" className="footer-link">
            Pricing
          </Link>
          <Link to="/contacts" className="footer-link">
            Contacts
          </Link>
        </div>

        <div className="footer-contact">
          <a href="tel:+37126409932" className="footer-contact-item">
            <PhoneIcon fontSize="small" />
            <span>+371 26 409 932</span>
          </a>
          <a href="mailto:info@rigadentique.lv" className="footer-contact-item">
            <EmailIcon fontSize="small" />
            <span>info@rigadentique.lv</span>
          </a>
          <a
            href="https://maps.google.com/?q=Matīsa+iela+46+Rīga"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-contact-item"
          >
            <PlaceIcon fontSize="small" />
            <span>Matīsa iela 46, Rīga</span>
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="footer-copyright">
          © {year} Riga Dentique. All Rights Reserved.
        </p>
        <div className="footer-socials">
          <a
            href="https://www.instagram.com/rigadentique"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            className="footer-social-link"
          >
            <InstagramIcon fontSize="small" />
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61563532634999"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            className="footer-social-link"
          >
            <FacebookIcon fontSize="small" />
          </a>
        </div>
      </div>
    </footer>
  );
};
